<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formAgravo.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Apólice</span>
          <v-select
            :options="listApolices"
            name="Tipo de Apólice"
            id="Tipo de Apólice"
            v-model="formAgravo.idTipoApolice"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            placeholder="Selecione"
            :state="validateState(veeFields, veeErrors, 'Tipo de Apólice')"
            :class="validateStateClass(veeFields, veeErrors, 'Tipo de Apólice')"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Pergunta</span>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-help-circle"
            v-model="formAgravo.pergunta"
            id="Pergunta"
            name="Pergunta"
            v-validate="'required'"
            :state="validateState(veeFields, veeErrors, 'Pergunta')"
            :class="validateStateClass(veeFields, veeErrors, 'Pergunta')"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Aplicar todos os grupos?</span>
          <vs-switch
            color="success"
            v-model="formAgravo.grupoComum"
            style="width: 55px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>
      <div v-if="!formAgravo.grupoComum" class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>Grupos Específicos</span>
          <v-select
            :options="listGrupos"
            name="grupos Especificos"
            id="grupos Especificos"
            v-model="formAgravo.gruposEspecificos"
            multiple
            placeholder="Selecione"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>Sequência</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravo.sequencia"
            id="Sequência"
            name="Sequência"
            v-validate="'required|min_value:1'"
            :state="validateState(veeFields, veeErrors, 'Sequência')"
            :class="validateStateClass(veeFields, veeErrors, 'Sequência')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>Tag HTML</span>
          <v-select
            :options="listTags"
            name="Tag HTML"
            id="Tag HTML"
            v-model="formAgravo.tag_html"
            v-validate="{ required: true }"
            placeholder="Selecione"
            :state="validateState(veeFields, veeErrors, 'Tag HTML')"
            :class="validateStateClass(veeFields, veeErrors, 'Tag HTML')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Prince API</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravo.integrations.prince.id"
            id="id-prince-api"
            name="id-prince-api"
            v-validate="'required|min_value:1'"
            :state="validateState(veeFields, veeErrors, 'id-prince-api')"
            :class="validateStateClass(veeFields, veeErrors, 'id-prince-api')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Questionário Star</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravo.integrations.star.questionaryId"
            id="id-questionary-star"
            name="id-questionary-star"
            v-validate="'required|min_value:1'"
            :state="validateState(veeFields, veeErrors, 'id-questionary-star')"
            :class="
              validateStateClass(veeFields, veeErrors, 'id-questionary-star')
            "
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Pergunta Star</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravo.integrations.star.questionId"
            id="id-question-star"
            name="id-question-star"
            v-validate="'required|min_value:1'"
            :state="validateState(veeFields, veeErrors, 'id-question-star')"
            :class="
              validateStateClass(veeFields, veeErrors, 'id-question-star')
            "
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-6">
          <span>ID Pergunta I4Pro</span>
          <vs-input
            type="number"
            step="1"
            class="w-full"
            icon-pack="feather"
            icon="icon-chevrons-right"
            v-model="formAgravo.integrations.i4pro.id"
            id="id-question-i4pro"
            name="id-question-i4pro"
            :state="validateState(veeFields, veeErrors, 'id-question-i4pro')"
            :class="
              validateStateClass(veeFields, veeErrors, 'id-question-i4pro')
            "
          />
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="dados == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';

import service from '../../../../services';
import utilsList from '../../../../utils/list/index';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';

export default {
  name: 'form-agravos-proposta',
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    ErrorsAlert,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  data() {
    return {
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      formAgravo: {
        idAgravo: null,
        status: false,
        idTipoApolice: null,
        pergunta: null,
        grupoComum: false,
        gruposEspecificos: null,
        sequencia: null,
        tag_html: null,
        integrations: {
          prince: {
            id: null,
          },
          star: {
            questionaryId: null,
            questionId: null,
          },
          i4pro: {
            id: null,
          },
        },
      },
      listApolices: [],
      listGrupos: [],
      listTags: [
        'select',
        'checkbox',
        'radio',
        'button',
        'autocomplete',
        'multipleButtons',
      ],
    };
  },
  mounted() {
    this.getDominios();
  },
  methods: {
    preencheForm() {
      if (!this.dados) {
        this.resetForm();
        return;
      }
      this.formAgravo.idAgravo = this.dados.idAgravo;
      this.formAgravo.status = this.dados.deletedAt ? false : true;
      this.formAgravo.idTipoApolice = this.dados.idTipoApolice;
      this.formAgravo.pergunta = this.dados.pergunta;
      this.formAgravo.grupoComum = this.dados.grupoComum;
      this.formAgravo.sequencia = this.dados.sequencia;
      this.formAgravo.tag_html = this.dados.tag_html;

      if (this.dados.integrations) {
        const integrations = this.dados.integrations;

        if (integrations.prince) {
          this.formAgravo.integrations.prince = integrations.prince;
        }

        if (integrations.star) {
          this.formAgravo.integrations.star = integrations.star;
        }

        if (integrations.i4pro) {
          let i4proId = null;
          if (
            integrations.i4pro.id !== undefined &&
            integrations.i4pro.id !== null
          ) {
            i4proId = integrations.i4pro.id;
          } else if (
            integrations.i4pro.questionId !== undefined &&
            integrations.i4pro.questionId !== null
          ) {
            i4proId = integrations.i4pro.questionId;
          }
          this.formAgravo.integrations.i4pro = { id: i4proId };
        }
      }

      if (Array.isArray(this.dados.gruposEspecificos)) {
        this.formAgravo.gruposEspecificos = this.dados.gruposEspecificos.reduce(
          (acumulador, atual) => {
            const grupo = this.listGrupos.find((g) => g.id === atual);

            if (grupo) {
              acumulador.push(grupo);
            }
            return acumulador;
          },
          [],
        );
      }
    },
    getDominios() {
      try {
        if (this.listApolices.length === 0) {
          functions.buscaDadosSelects(
            'tipoApolices',
            this.listApolices,
            'nome',
            'tipoApoliceId',
          );
        }

        if (this.listGrupos.length === 0) {
          functions.buscaDadosSelects(
            'gruposVeiculos',
            this.listGrupos,
            'nomeGrupo',
            'idGrupo',
            undefined,
            true,
          );
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    onReset() {
      this.resetForm();
      this.$emit('cancel');
    },
    resetForm() {
      this.formAgravo = {
        idAgravo: null,
        status: false,
        idTipoApolice: null,
        pergunta: null,
        grupoComum: false,
        gruposEspecificos: null,
        sequencia: null,
        tag_html: null,
        integrations: {
          prince: {
            id: null,
          },
          star: {
            questionaryId: null,
            questionId: null,
          },
          i4pro: {
            id: null,
          },
        },
      };
    },
    async onSubmit() {
      const validated = await this.$validator.validateAll();
      if (!validated) {
        return;
      }

      try {
        this.$vs.loading();
        this.formAgravo.integrations = JSON.stringify(
          this.formAgravo.integrations,
        );

        await service.post('agravos', 'agravos-proposta', this.formAgravo);

        this.formAgravo.integrations = this.formAgravo.integrations;

        notify.notifySuccess(this.$vs, 'Operação realizada com sucesso!');

        this.resetForm();
        this.$emit('concluido');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style lang="scss"></style>
